/**
 * Iconos del rail estrecho + switch de contexto (superadmin).
 * Regla: en el mismo rail no puede repetirse el mismo `data-icon`.
 *
 * Modo tenant: módulos 1–6 + switch (≠ ningún railIcon de esos módulos).
 * Modo platform: solo módulo Plataforma + switch (dos iconos distintos).
 * Modo pos: solo módulo POS (sin switch de plataforma).
 */
export const ADMIN_SHELL_NAV_ICONS = {
  /** Rail módulo Plataforma (modo platform). */
  platformRail: 'solar:buildings-3-line-duotone',
  /** Resumen / home del dueño SaaS. */
  platformOverviewNav: 'solar:chart-2-line-duotone',
  /** Tenants en panel lateral (varios negocios / cuentas; ≠ rail Plataforma). */
  platformTenantsNav: 'solar:users-group-two-rounded-line-duotone',
  /** Leads comerciales de plataforma. */
  platformLeadsNav: 'solar:user-speak-rounded-line-duotone',
  /** Planes comerciales (cupos / entitlements). */
  platformPlansNav: 'solar:card-2-line-duotone',
  /** Imágenes del sistema (logos reutilizables de bancos / métodos de pago). */
  platformSystemImagesNav: 'solar:gallery-line-duotone',
  platformLegalNav: 'solar:document-text-line-duotone',
  /** Rail módulo Milinco (modo tenant). */
  businessRail: 'solar:shop-2-line-duotone',
  /** Entrada Ventas → POS (tenant); Tabler cash-register outline. */
  posRail: 'tabler:cash-register',
  posVenta: 'solar:cart-large-minimalistic-line-duotone',
  /** Mesa restaurante (Material Symbols Light rounded). */
  posMesas: 'material-symbols-light:table-restaurant-outline-rounded',
  /** Tablero pedidos (Ventas + rail POS); Solar line-duotone = mismo trazo que el rail. */
  posTablero: 'solar:widget-4-line-duotone',
  posCarritos: 'solar:bag-3-line-duotone',
  /** Pedidos / tickets (≠ transferencias de inventario). */
  posTransacciones: 'solar:clipboard-list-line-duotone',
  posInforme: 'solar:chart-square-line-duotone',
  posTraslado: 'solar:safe-2-line-duotone',
  /** Turnos de caja (arqueo apertura/cierre); ≠ posTraslado en el mismo rail. */
  posTurnos: 'solar:clock-circle-line-duotone',
  posConfig: 'solar:settings-minimalistic-line-duotone',
  posExit: 'solar:arrow-left-line-duotone',
  /** Switch → Plataforma (modo tenant). */
  switchToPlatform: 'solar:global-line-duotone',
  /** Switch → Milinco (modo platform; ≠ edificios del módulo Plataforma). */
  switchToMilinco: 'solar:home-2-line-duotone',
} as const;
